import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { useFieldValidation } from "../hooks/validation.hooks";
import { validateEmail } from "../services/validation";
import styled from "@emotion/styled";

const FullNameAndEmail = ({
  onChange,
  cleanValues = false,
  setCleanValues,
}) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    onChange({ email, fullName });
  }, [fullName, email, onChange]);

  useEffect(() => {
    if (cleanValues) {
      setEmail("");
      setFullName("");
      setCleanValues(false);
    }
  }, [cleanValues, setEmail, setFullName, setCleanValues]);

  const emailInput = useFieldValidation();


  const validateMail = (value) => {
    if (!validateEmail(value)) {
      emailInput.setErrorMessage("כתובת המייל לא תקין");
      return true;
    }
    emailInput.setErrorMessage(null);
  };



  return (
    <Container>
      <TextField
        id="name"
        label="*שם מלא"
        value={fullName}
        onChange={({ target }) => {
          setFullName(target.value);
        }}

      />
      <TextField
        id="mail"
        label="*אימייל"
        value={email}
        onChange={({ target }) => {
          setEmail(target.value.trim());
          validateMail(target.value.trim());
        }}
        error={Boolean(email) && emailInput.isTouched && !emailInput.isValid}
        helperText={
          Boolean(email) && emailInput.isTouched && emailInput.errorMessage
        }
        onFocus={() => {
          emailInput.inputProps.onFocus();
        }}
        onBlur={() => {
          emailInput.inputProps.onBlur();
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  max-width: 680px;
  direction: rtl;
  padding-bottom: 15px;
  padding-top: 15px;
  > * {
    margin-left: 20px;
  }

`;

export default FullNameAndEmail;
